import React from "react";
import { oneOfType, bool, func, string, number } from "prop-types";
import * as styles from "./styles.module.scss";

const CheckboxButton = ({ isChecked, onClick, label, groupName, width }) => {
  return (
    <label
      style={{ fontSize: "18px" }}
      className={`btn ${
        isChecked ? "btn-info" : `btn-outline-info ${styles.dark}`
      } mb-0 col-12 ${width === "50%" ? "col-sm-6" : "col-sm-4"}`}
    >
      <input
        type="checkbox"
        name={groupName}
        defaultChecked={isChecked}
        onClick={onClick}
        autoComplete="off"
        style={{
          position: "absolute",
          clip: "rect(0,0,0,0)",
          pointerEvents: "none",
        }}
      />
      {label}
    </label>
  );
};

CheckboxButton.propTypes = {
  isChecked: bool,
  onClick: func,
  label: string,
  groupName: string,
  width: oneOfType([string, number]),
  asTickBox: bool,
};

export default CheckboxButton;
